import { Box, Divider, Typography } from '@material-ui/core';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useThemeQueries } from 'views/theme';
import { ResultadoRevendaModel } from 'model/api/gestao/relatorios/resultado-revenda-model';
import { useStyles } from '../../../accordion-revenda/components/saldo/saldo-styles';
import { RelatorioChartModel, RelatorioUnitarioChartModel, saldoRevendaPosicaoName } from 'model/api/gestao/relatorios/relatorio-model';
import { converterDateToCompetencia, subtrairCompetencia } from 'utils/converter-competencia';
import ChartPosicao from '../chart-posicao/chart-posicao';

interface DashboardSaldoProps {
    resultadoRevenda: ResultadoRevendaModel[];
    meses: number;
}

export default function PosicoesRevenda({ resultadoRevenda, meses }: DashboardSaldoProps) {
    const { theme } = useThemeQueries()

    const chartContainerRef = useRef<HTMLDivElement>(null)

    const classes = useStyles({ showOverflow: meses >= 24, chartContainerRef });

    const [dadosContratos, setDadosContratos] = useState<RelatorioChartModel[]>([])

    const tratarDados = useCallback(() => {
        try {
            let arr: RelatorioChartModel[] = [
                new RelatorioChartModel('contratosSaldoPosicao', []),
                new RelatorioChartModel('cnpJsSaldoPosicao', []),
                new RelatorioChartModel('terminaisSaldoPosicao', [])
            ]
            const competenciaAtual = converterDateToCompetencia(new Date())

            for (let i = 0; i <= meses; i++) {
                const competenciaSubtraida = subtrairCompetencia(competenciaAtual, i)
                const foundItem = resultadoRevenda.find(element => element.anoMes === competenciaSubtraida)
                if (foundItem) {
                    arr = arr.map(element => {
                        const property = element.name as saldoRevendaPosicaoName

                        element.data.push(new RelatorioUnitarioChartModel(competenciaSubtraida, foundItem[property],))
                        return element
                    })
                }
            }

            setDadosContratos(arr.map(item => {
                item.data = item.data.sort((a, b) => a.x - b.x)
                switch (item.name) {
                    case 'cnpJsSaldoPosicao':
                        item.name = 'Posição Novos CNPJs'
                        break;
                    case 'contratosSaldoPosicao':
                        item.name = 'Posição Novos Contratos'
                        break;
                    case 'terminaisSaldoPosicao':
                        item.name = 'Posição Novos Terminais'
                        break;
                }
                return item
            }))
        } catch (e) {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resultadoRevenda])

    useEffect(() => {
        tratarDados()
    }, [tratarDados])


    return (
        <>
            <Box display='flex' flexDirection='column' width='100%' gridGap={theme.spacing(1)}>
                <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap' gridGap={5}>
                    <Typography color='primary' variant='h6'>Saldo</Typography>
                </Box>
                <Divider />
                <div className={classes.chartContainer} ref={chartContainerRef}>
                    <ChartPosicao list={dadosContratos} width={
                        meses >= 24 ? meses * 100 : undefined
                    } />
                </div>
            </Box>
        </>
    );
}